import Utils from "../utils/utils";
import Bridge, { BridgeMessage } from "./bridge";
import { BridgeMessageTypeOpenURL } from "./bridge.types";

export default class BridgeOpenURL extends Bridge {
  constructor() {
    super();
  }
    
  public async openAsync(url:string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const message: BridgeMessage = {
        uuid: Utils.UUID(),
        type: BridgeMessageTypeOpenURL,
        data: { url: url },
      };
      this.send(message, resolve, reject);
    });
  }
}